// GrowthBook flag names that BOTH the API and a frontend read.
//
// Shared because a flag read on two sides is one string, and this repo has no
// registry: the server has written its names in kebab-case (`article-image-review`)
// and the webapp in SCREAMING_SNAKE (`EXPERIMENTAL`), so two literals in two apps
// is a bug waiting for a typo. Pure data, no deps — safe in a frontend bundle, the
// same reason `evidence-models.ts` lives here.
//
// A flag read on ONE side only does not belong here; keep it at its call site.

/** NPI lookup and identifier collection in the API and webapp. */
export const HCP_PREFILL_US_FLAG = "hcp-prefill-us";

/** BIG lookup and Dutch identifier collection in the API and webapp. */
export const HCP_PREFILL_NL_FLAG = "hcp-prefill-nl";

/** Ordem dos Médicos lookup and Portuguese physician identifier collection. */
export const HCP_PREFILL_PT_FLAG = "hcp-prefill-pt";

/** Health Pro lookup and Belgian identifier collection in the API and webapp. */
export const HCP_PREFILL_BE_FLAG = "hcp-prefill-be";

/** REPS name search and Spanish source-only directory selection. */
export const HCP_PREFILL_ES_FLAG = "hcp-prefill-es";

/**
 * Who talks to the assistant engine. The API 404s every `/assistant` route when
 * it is off; the webapp keeps the legacy chat for those readers.
 */
export const ASSISTANT_ENGINE_FLAG = "assistant-engine";

/**
 * The assistant debug drawer. The API 404s its four `/debug` routes when it is off.
 * Target `email`: `id` differs between the API and the webapp.
 */
export const ASSISTANT_DEBUG_FLAG = "assistant-debug";

/** STPS lookup and Danish identifier collection. */
export const HCP_PREFILL_DK_FLAG = "hcp-prefill-dk";
